'use client';

import { SEARCH_DIALOG_RESULTS_PAGE_SIZE } from '@/components/pages/search/search-constants';
import type { SearchResult } from '@/components/pages/search/search-types';
import { useQuery } from '@tanstack/react-query';

const SEARCH_RESULTS_CACHE_KEY = 'search-results';

async function getSearchResults({
  query,
  page = 1,
  maxResults,
}: {
  query: string;
  page?: number;
  maxResults: number;
}): Promise<SearchResult> {
  const response = await fetch(
    `/api/sanity/search?q=${encodeURIComponent(query)}&page=${page}&maxResults=${maxResults}`
  );
  if (!response.ok) {
    return [];
  }
  return response.json();
}

export function useSearchResults({
  query,
  page = 1,
  enabled,
}: {
  query: string;
  page?: number;
  enabled: boolean;
}) {
  return useQuery({
    queryKey: [SEARCH_RESULTS_CACHE_KEY, query, page],
    queryFn: () =>
      getSearchResults({
        query,
        page,
        maxResults: SEARCH_DIALOG_RESULTS_PAGE_SIZE,
      }),
    enabled: enabled && query !== '',
  });
}
